<!-- @format -->

<chat-index-tag>

	<div class="container_contents">
			
		<div class="container_breadcrumb">
			<ul class="breadcrumb">
				<li class="breadcrumb-item"><h1 class="heading-01 heading_chat">チャットルーム</h1></li>
			</ul>
		</div><!--/.container_breadcrumb-->
		
		<div class="contents">
			<ul class="alert_message01 margin-spacing-1_bottom" if={!state.basicinfoFilled}>
				<li class="alert_message01-item "><a href="/info">本人確認書類が未提出です（お仕事の受託やクライアント様との交渉ができません）</a></li>
			</ul><!--/.alert_message-->
			<section class="contents_area">
        <p class="text margin-spacing-4_bottom">クライアント様とのチャット履歴の一覧です。</p>
        
        <div class="container_sort margin-spacing-2_bottom">
          <div class="box_sort">
            <div class="sort-menu margin-spacing-2_right">
              <input 
                class="sort-list" 
                type="text" 
                name="client_id" 
                placeholder="全てのクライアント" 
                is="suggest-tag" 
                data="{state.options}"
                val=""
                onchoose="{limitClientId}"
              /><!--/input-->
              <select name="sort" class="sort-list" onchange="{(e)=>changeActive(e)}">
                <option value="0">全て</option>
                <option value="1">稼働中</option>
                <option value="2">最近のチャット</option>
              </select>
            </div><!--/.sort-menu-->
          </div><!--/.box_sort-->
          <p if={ state.clients.length > 0} class="search_number">全{state.total}件中　{state.start}〜{state.end}件</p>
        </div><!--/.container_sort-->	
        <client-item-tag client={client} idx={i} each={(client,i) in state.clients}></client-item-tag>
        <div class="empty margin-spacing-3_top" if={ state.clients.length === 0}>
          <!-- 履歴が存在しない場合　ここから -->
          <p class="empty-message">チャット履歴はありません。</p>
          <!-- 履歴が存在しない場合　ここまで -->
        </div>

        <edilent-pagination-tag pager="{state.pager}" onpager="{(e,page)=>select(e,page)}" if={state.pager.last > 1}></edilent-pagination-tag>


			</section><!--/.contents_area-->
			
		</div><!--/.contents-->
	</div><!--/.container_contents-->

<script>
  import di from "dependeny-injection";
  import clientItem from "@tags/pages/chat/client-item.riot";
  import suggestTag from "@tags/parts/suggest.riot";


  export default {
    components: {
      'client-item-tag': clientItem,
      'suggest-tag': suggestTag
    },
    state: {
  		basicinfoFilled: true,
      active: false,
      latest: false,
      clientId: null,
      clients: [],
      options: [],
      page: 1,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0},
      total: 0,
      start: 0,
      end: 0
    },
    limitClientId(e) {
      this.state.page = 1;
      this.state.clientId = e.target.getAttribute('val');
      this.fetchClients();
    },
    changeActive(e) {
      this.state.page = 1;
      this.state.active = (e.target.value == "1")?true:false;
      this.state.latest = (e.target.value == "2")?true:false;
      this.fetchClients();
    },
    select(e, page) {
      e.preventDefault();
      this.state.page = page;
      this.fetchClients();
    },
    onClientsUpdate(data){
      this.state.clients = data.items;
      this.state.pager   = data;
      this.state.page    = data.page;
      this.state.total   = data.total;
      this.state.start   = (data.page - 1)*10 + 1;
      this.state.end     = (data.page - 1)*10 + (data.items.length);
      this.update();
    },
    fetchClients(){
      const params = {
        page  : this.state.page,
        active: this.state.active,
        latest: this.state.latest,
        clientId : this.state.clientId
      };
      this.api.request('index', 'clients', params)
        .then(data=>this.onClientsUpdate(data));
    },
    fetchOptions() {
      this.api.request('index', 'options')
        .then(data=>this.update({options: data}));
    },
    fetchBasicinfoFilled(){
      di.createApi('menu').request('index', 'check-basic-info-filled')
        .then(data=>this.update({basicinfoFilled: data}));
    },
    onBeforeMount(){
      this.api = di.createApi('chat');
      this.fetchClients();
      this.fetchOptions();
      this.fetchBasicinfoFilled();
    }
  }
</script>
</chat-index-tag>
